import { FC } from 'react';
import { Box } from 'ui/Box';
import { styles } from './styles';
import { CheckboxProps, Checkbox as MuiCheckbox } from 'ui/Checkbox';
export interface CustomCheckboxProps extends CheckboxProps {}
export const Checkbox: FC<CustomCheckboxProps> = (props) => {
  return (
    <MuiCheckbox
      disableRipple
      sx={styles.checkbox}
      checkedIcon={<Box sx={styles.checked} />}
      icon={<Box sx={styles.icon} />}
      {...props}
    />
  );
};
